/**
 * Modulo para recuperar que feature de nibara están activadas.
 * @author Felipe Galindo <fgalindo@vocento.com>
 */

const DEFAULT_COOKIE_LAW = 0;
const DEFAULT_BREAKING_NEWS = 1;
const DEFAULT_TE_INTERESA = 1;
const DEFAULT_PUSH_NOTIFICATION = 1;
const DEFAULT_SHARE_LAYER = 1;
const DEFAULT_HOME_BACKTRACE = 1;
const DEFAULT_STICKY_ADS = 1;
const DEFAULT_JQ_STICKY_ADS = 0;

const app = Voonto.getInstance();
const configFeature = app.lookup('vocento.config.nibara.feature');
const urlParams = nibara.nTools.getUrlParams();

function getFeatureParam(name)
{
	return urlParams.queryParams[name] || urlParams.queryHash[name] || configFeature[name];
}

function getFeatures()
{

	const pStickyAds = getFeatureParam('stickyAds');
	const pJqStickyAds = getFeatureParam('jqStickyAds');
	const pBreakingNews = getFeatureParam('breakingNews');
	const pCookieLaw = getFeatureParam('cookieLaw');
	const pPushNotification = getFeatureParam('pushNotification');
	const pTeInteresa = getFeatureParam('teInteresa');
	const pShareLayer = getFeatureParam('shareLayer');
	const pHomeBacktrace = typeof history.state === 'undefined' ? 0 : getFeatureParam('homeBacktrace');

	return {
		"stickyAds": pStickyAds === undefined ? DEFAULT_STICKY_ADS : (pStickyAds|0),
		"jqStickyAds": pJqStickyAds === undefined ? DEFAULT_JQ_STICKY_ADS : (pJqStickyAds|0),
		"breakingNews": pBreakingNews === undefined ? DEFAULT_BREAKING_NEWS : (pBreakingNews|0),
		"teInteresa": pTeInteresa === undefined ? DEFAULT_TE_INTERESA : (pTeInteresa|0),
		"cookieLaw": pCookieLaw === undefined ? DEFAULT_COOKIE_LAW : (pCookieLaw|0),
		"pushNotification": pPushNotification === undefined ? DEFAULT_PUSH_NOTIFICATION : (pPushNotification|0),
		"shareLayer": pShareLayer === undefined ? DEFAULT_SHARE_LAYER : (pShareLayer|0),
		"homeBacktrace": pHomeBacktrace === undefined ? DEFAULT_HOME_BACKTRACE : (pHomeBacktrace|0),
	};
}

export default getFeatures;



// WEBPACK FOOTER //
// ./src/feature.js